webpackJsonp([119609562465818],{

/***/ 444:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"frontmatter":{"title":"Rakuen","path":"/rakuen"}}},{"node":{"frontmatter":{"title":"To the Moon/Finding Paradise Review","path":"/to-the-moon"}}}]}},"pathContext":{"tag":"Review"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-review-1f3c81b065a11c4600d9.js